import { useState } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Packages from "@/components/Packages";
import BuildYourBar from "@/components/BuildYourBar";
import SignatureCocktails from "@/components/SignatureCocktails";
import Gallery from "@/components/Gallery";
import Reviews from "@/components/Reviews";
import BookingForm from "@/components/BookingForm";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";

export default function Landing() {
  const [build, setBuild] = useState({ pkg: "", addons: [], hours: 0, extraGuests: 0 });

  return (
    <div className="bg-cream text-espresso">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Packages />
        <BuildYourBar build={build} setBuild={setBuild} />
        <SignatureCocktails />
        <Gallery />
        <Reviews />
        <BookingForm build={build} />
        <Faq />
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}
